import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtrlSidebarComponent } from './ctrl-sidebar/ctrl-sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { OtnavbarComponent } from './otnavbar/otnavbar.component';
import { OtnavbarpcComponent } from './otnavbarpc/otnavbarpc.component';
import { MainSidebarComponent } from './main-sidebar/main-sidebar.component';
import { OtmainSidebarpcComponent } from './otmain-sidebarpc/otmain-sidebarpc.component';
import { FooterComponent } from './footer/footer.component';
// import { LightboxComponent } from './lightbox/lightbox.component';
import { Routes, RouterModule } from '@angular/router';
import { OtmainSidebarmoblieComponent } from './otmain-sidebarmoblie/otmain-sidebarmoblie.component';

@NgModule({
  declarations: [ CtrlSidebarComponent, NavbarComponent,OtnavbarComponent,OtnavbarpcComponent, MainSidebarComponent,FooterComponent,OtmainSidebarpcComponent,OtmainSidebarmoblieComponent],
  imports: [
    CommonModule,RouterModule,
  ],
  exports: [ // 可借花獻佛
     CtrlSidebarComponent, NavbarComponent,OtnavbarComponent,OtnavbarpcComponent, MainSidebarComponent, FooterComponent,OtmainSidebarpcComponent,OtmainSidebarmoblieComponent
  ]
})

export class LayoutModule { }
